/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useParams, useHistory, useLocation, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import TextareaAutosize from 'react-textarea-autosize';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route, route_name } from "./@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, console_dev_line } from '../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from './@components/credit'
import OverlayBg from '../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/
    const { slug } = useParams();
    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useLocation]
    ----------------------------------------------------------------*/
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery(); // query.get("order_id")
    /*--------------------------------------------------------------
    [End useLocation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Chat';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route API]
    ----------------------------------------------------------------*/
    let route_api = route;
    /*--------------------------------------------------------------
    [End Route API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route Path]
    ----------------------------------------------------------------*/
    let route_path = 'forum';
    /*--------------------------------------------------------------
    [End Route Path]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'forum';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Private]
    ----------------------------------------------------------------*/
    let PRIVATE = true;
    /*--------------------------------------------------------------
    [End Private]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);
    const [filter, set_filter] = useState(null);
    const [sub_filter, set_sub_filter] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [queue, set_queue] = useState(false)
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [end_element, set_end_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_user, set_data_user] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Looping Input]
    ----------------------------------------------------------------*/
    const input = [
        {
            name : 'test',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },

        {
            name : 'submit',
            element : 'submit',
            text_transform : 'capitalize',
            submit_file: false
        }
    ]

    const input_obj = {
        test : test
    }
    /*--------------------------------------------------------------
    [End Looping input]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response ${request_params} read`, response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}

    const _read_user = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        API_GET_REQUEST(`forum/user/get__________?action=read`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response forum user read`, response.data)
            if(response.data.result == 'success'){
                set_data_user(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}

    const _search = () => {

        if(queue === true){
            return
        }
        
        if(search.length > 3){

            set_queue(true)
    
            API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response ${request_params} search`, response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_queue(false)
            })

        }

    }

    const _uploads = (action) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        
        input && input.map((x, i)=> {
            if(x.element !== 'submit' && x.element !== 'file'){
                data.append(x.name, eval(x.name))
            }
        })

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + `${route_api}/${route_path}/post__________`,
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response ${request_params} uploads`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                
                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
            set_queue(false)
		})

    }

    const _uploads_post = (params) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

		API_POST(`${route_api}/${route_path}/post__________`, {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            ...input_obj
		}).then((response) => {
            console_dev(`response ${request_params} uploads post`, response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')

                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    
    const _files_multiple = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        let data = [...event.target.files]
        
        if(data){

            console_dev('data', data)

            data.map((item, index) => {
                // console.log('item', data)
                if(item.size > 2048000){
                    return error('Ukuran File maxsimal 2MB')
                }else{
                    set_file([...data])
                }

            })

        }
        
	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = (storageUserParams) => {

        socket.emit("chat_user_connected", {
            status: 'online',
            uniquename : storageUserParams.uniquename,
            name : storageUserParams.name,
            path : storageUserParams.path,
            photo : storageUserParams.photo,
            e_account : storageUserParams.e_account,
        });
        
	}

    const _socket_room_me = (storageUserParams) => {

        socket.emit("chat_room", {
            room : storageUserParams.room,
            uniquename : storageUserParams.uniquename
        })

    }
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            let storage_bamboo_chain = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            set_bamboo_user(storage_bamboo)

            _socket_room_me(STORAGE_USER[0])
            _read_user(1, storage_bamboo)
            
        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(PRIVATE === true){
        if(STORAGE_USER !== undefined){
            if(STORAGE_USER[0].level === 'guest'){
                history.push('/')
            }
        }else{
            history.push('/home')
            window.location.reload();
        }
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 10)
        }

    }, [data])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Chat]
    ----------------------------------------------------------------*/

    const [socket_id, set_socket_id] = useState('');
    const [data_chat_user, set_data_chat_user] = useState([]);
    const [user_selected, set_user_selected] = useState(null);
    const [data_chat_message, set_data_chat_message] = useState([]);
    const [chat, set_chat] = useState('');

    const _chat_send = () => {

        socket.emit("chat_send", {
            to_room: user_selected.room,
            to_status: 'online',
            to_uniquename : user_selected.uniquename,
            to_name : user_selected.name,
            
            from_room : STORAGE_USER[0].room,
            from_status : 'online',
            from_uniquename : STORAGE_USER[0].uniquename,
            from_name : STORAGE_USER[0].name,
            
            message: chat,
            e_account : user_selected.e_account,
        });

        set_chat('')

    }

    const _join_room = (data) => {

        set_user_selected(data)

        socket.emit("chat_room_join", {

            to_room: data.room,
            to_status: 'online',
            to_uniquename : data.uniquename,
            to_name : data.name,
            
            from_room : STORAGE_USER[0].room,
            from_status : 'online',
            from_uniquename : STORAGE_USER[0].uniquename,
            from_name : STORAGE_USER[0].name,
            
            message: STORAGE_USER[0].uniquename + ' ' + 'Joined to room' + ' ' + data.uniquename,
            e_account : data.e_account,
            
        });

    }

    useEffect(() => {

        socket.on("chat_room", (data) => {
            console_dev_line('----------------------------------------------------------');
			console_dev_line('@chat_room');
			console_dev_line('----------------------------------------------------------');
			console_dev_line(data)
		})

        socket.on("chat_room_join", (data) => {
            console_dev_line('----------------------------------------------------------');
			console_dev_line('@chat_room_join');
			console_dev_line('----------------------------------------------------------');
			console_dev_line(data)
		})

        socket.on("chat_send", (data) => {
            console_dev_line('----------------------------------------------------------');
			console_dev_line('@chat_send');
			console_dev_line('----------------------------------------------------------');
			console_dev_line(data)
            if(STORAGE_USER[0].uniquename !== data.from_uniquename){
                error(data.from_name + ' Send You Message')
            }
            data_chat_message.push(data)	
            set_data_chat_message([...data_chat_message]);
		})

        // socket.on("socket_id", (data) => {
        //     console_dev_line('----------------------------------------------------------');
		// 	console_dev_line('@socket_id');
		// 	console_dev_line('----------------------------------------------------------');
		// 	console_dev_line(data)
        //     set_socket_id(data)
		// })
        
        // socket.on("chat_user_connected", (data) => {
        //     console_dev_line('----------------------------------------------------------');
		// 	console_dev_line('@chat_user_connected');
		// 	console_dev_line('----------------------------------------------------------');
		// 	console_dev_line(data)
        //     data_chat_user.push(data)	
        //     set_data_chat_user([...data_chat_user]);
		// })

        // socket.on("chat_user_disconnected", (data) => {
        //     console_dev_line('----------------------------------------------------------');
		// 	console_dev_line('@chat_user_disconnect');
		// 	console_dev_line('----------------------------------------------------------');
		// 	console_dev_line(data)
		// })

    }, [])
    
    /*--------------------------------------------------------------
    [End Chat]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}
            
            <div className="_container _lily_pad_h_d">
                <div style={{padding: 20, position: 'fixed', top: 0, left: 0, bottom: 0, width: 320, backgroundColor: '#fff', overflowY: 'auto', borderRightWidth: 1, borderRightColor: '#eee', borderRightStyle: 'solid'}}>
                    <h2 className="_push_b_d">MegaMera</h2>
                    {
                        data_user && data_user.list.map((item, index) => {
                            if(STORAGE_USER[0].uniquename !== item.uniquename){
                                return(
                                    <div style={{cursor: 'pointer'}} key={index} onClick={() => {
                                        _join_room(item)
                                    }}>
                                        <div className="_row _center_align _push_b_m">
                                            <div style={{marginRight: 10, position: 'relative', height: 50, width: 50, borderRadius: 70, backgroundColor: '#f5f5f5', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER}/${item.path}/${item.photo})`}}>
                                            
                                            </div>
                                            <div className="_column">
                                                <p>{item.name}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
                <div style={{padding: 20, position: 'fixed', top: 0, left: 320, bottom: 0, right: 0, backgroundColor: '#f9f9fa', overflowY: 'auto', display: 'flex', flexDirection: 'column'}}>
                    <div style={{flex: 1}}>
                        {
                            STORAGE_USER &&
                            data_chat_message.map((item, index) => {
                                return(
                                    <div key={index} className="_row _center_align _push_b_s">
                                        <div className={STORAGE_USER[0].uniquename === item.from_uniquename ? "_column" : null}>

                                        </div>
                                        <div>
                                            <div className="_row" style={{alignItems: 'flex-end', backgroundColor: 'seagreen', color: '#fff', borderRadius: 32, padding: 16, paddingTop: 8, paddingBottom: 8}}>
                                                {/* <p>{item.name}</p> */}
                                                <div className="_column">
                                                    <TextareaAutosize
                                                        style={{width: '100%', resize: 'none'}}
                                                        value={item.message}
                                                        placeholder={'Tulis Pesan'}
                                                    />
                                                </div>
                                                <div>
                                                    {item.clock}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        user_selected ?
                            <form onSubmit={() => _chat_send()}>
                                <div className="_row" style={{alignItems: 'flex-end'}}>
                                    <TextareaAutosize
                                        style={{width: '100%', resize: 'none', borderRadius: 32, marginRight: 10, backgroundColor: '#fff', padding: 20, paddingTop: 16, paddingBottom: 16, borderWidth: 1, borderColor: '#eee', borderStyle: 'solid'}}
                                        minRows={0}
                                        maxRows={6}
                                        onChange={e => set_chat(e.target.value)}
                                        value={chat}
                                        placeholder={'Tulis Pesan'}
                                    />
                                    <div onClick={() => _chat_send()} style={{position: 'relative', display: 'inline-block', height: 50, width: 50, backgroundColor: '#fff', borderRadius: 50, borderWidth: 1, borderColor: '#eee', borderStyle: 'solid'}}>
                                        <div className="_position_middle">

                                        </div>
                                    </div>
                                </div>
                            </form>
                        :
                            <div style={{position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, backgroundColor: '#fff'}}>
                                <div className="_position_middle">
                                    <h1>Mega Mera</h1>
                                    <p>Aplikasi Orang Indonesia</p>
                                </div>
                            </div>
                    }
                </div>
            </div>
            
        </>
    );

}

export default Screen;